module.exports = __webpack_public_path__ + "static/media/icon_jump.6c032bea.svg";